import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/User_pages/HomePage/Home";
import About from "../pages/User_pages/AboutPage/AboutPage";
import Login from "../pages/User_pages/login/Login";
import Signup from "../pages/User_pages/signup/Signup";
import Game from "../pages/User_pages/GamePage/Game";
import AdminLogin from "../layout/AdminPortal/AdminLogin/AdminLogin";
import AdminDashboard from "../layout/AdminPortal/AdminDashboard/AdminDashboard";
import GameSetup from "../pages/Admin_pages/GameSetup/GameSetup";
import Reports from "../pages/Admin_pages/Reports/Reports";
import RolesManagement from "../pages/Admin_pages/RolesManagement/RolesManagement";
import TournamentManagement from "../pages/Admin_pages/TournamentManagement/TournamentManagement";
import Transactions from "../pages/Admin_pages/Transactions/Transactions";
import UiManagement from "../pages/Admin_pages/UiManagement/UiManagement";
import UserManagement from "../pages/Admin_pages/UserManagement/UserManagement";
import ForgotPassword from "../pages/User_pages/login/ForgotPassword";
import ResetPassWord from "../pages/User_pages/ResetPassword/ResetPassword";
import LandingPage from "../pages/User_pages/HomePage/LandingPage";
import GinWelcomePage from "../pages/Games/GinRummy/WelcomePage/GinWelcomePage";
import Cards from "../components/Vs_Computer/Cards";
import Protected from "./Protected";
import MultiPlayerGame from "../components/Vs_Multiplayer/MultiplayerGame";
import MultiplayerWelcomePage from "../components/Vs_Multiplayer/MultiplayerWelcomePage/MultiplayerWelcomePage";
import VerifyMail from "../pages/User_pages/login/VerifyMail";
import Subscription from "../components/Vs_Multiplayer/Subscription";

const RoutePage = () => {

  return (
    <>

      <BrowserRouter>
        <Routes>
          {/* <Route index element={<Navbars />} /> */}
          <Route path="/" element={<Home />}>
            <Route path="/" element={<LandingPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/game" element={<Game />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/:resetpassword" element={<ResetPassWord />} />
            <Route path="/resend_verificationLink" element={<VerifyMail />} />

          </Route>

          <Route path="ginGame" element={<GinWelcomePage />} />
          <Route path="/cards" element={
            <Protected>
              <Cards />
            </Protected>
          } />

          <Route path="/ginGameMultiplayer" element={
            <Protected>
              <MultiplayerWelcomePage />
            </Protected>
          } />
          <Route path="/ginGameMultiplayer/multiplayer_Game" element={
            <Protected>
              <MultiPlayerGame />
            </Protected>
          } />

          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/adminDashboard" element={<AdminDashboard />} />
          <Route path="/GameSetup" element={<GameSetup />} />
          <Route path="/Reports" element={<Reports />} />
          <Route path="/admin/RolesManagement" element={<RolesManagement />} />
          <Route path="/TournamentManagement" element={<TournamentManagement />} />
          <Route path="/Transactions" element={<Transactions />} />
          <Route path="/UiManagement" element={<UiManagement />} />
          <Route path="/admin/userManagement" element={<UserManagement />} />
          <Route path="/subscription" element={<Subscription />} />

        </Routes>
      </BrowserRouter>
    </>)
}
export default RoutePage;